import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderContainer = styled.header`
  padding: 12px 0;
  position: sticky;
  top: 0;
  background: rgba(33, 0, 77, 0.95);
  z-index: 100;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
`;

export const HeaderContent = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 105px;

  @media (max-width: 1024px) {
    padding: 0 60px;
  }

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto;
    row-gap: 12px;
    column-gap: 20px;
    padding: 0 20px;
    align-items: center;
  }
`;

export const NavLinks = styled.nav`
  display: flex;
  gap: 48px;
  align-items: center;
  justify-self: start;

  @media (max-width: 1024px) {
    gap: 36px;
  }

  @media (max-width: 768px) {
    grid-column: 1 / span 2;
    grid-row: 2;
    gap: 16px;
    justify-content: center;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    padding-top: 12px;
  }
`;

export const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
  transition: all 0.3s ease;
  position: relative;
  opacity: 0.8;
  letter-spacing: 0.5px;

  &:hover {
    opacity: 1;
    color: #EBB800;
    transform: translateY(-1px);
  }

  &.active {
    opacity: 1;
    color: #EBB800;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 100%;
      height: 2px;
      background: linear-gradient(90deg, #EBB800 0%, #FFD700 100%);
      border-radius: 1px;
    }
  }

  @media (max-width: 1024px) {
    font-size: 22px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
    
    &.active::after {
      bottom: -6px;
    }
  }
`;

export const Logo = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  justify-self: center;

  img {
    height: 42px;
    width: auto;
    transition: all 0.3s ease;
    filter: brightness(1.1);
  }

  &:hover img {
    transform: scale(1.02);
    filter: brightness(1.2);
  }

  @media (max-width: 768px) {
    grid-column: 1;
    grid-row: 1;
    justify-self: start;
    
    img {
      height: 30px;
    }
  }
`;

export const NavRight = styled.div`
  display: flex;
  align-items: center;
  justify-self: end;
  gap: 24px;

  @media (max-width: 768px) {
    grid-column: 2;
    grid-row: 1;
    justify-self: end;
    gap: 12px;
  }
`;

export const CTAButton = styled.a`
  background-color: rgb(245, 124, 10);
  color: black;
  padding: 10px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 20px;
  font-weight: normal;
  transition: all 0.3s ease;
  border: 3px solid rgb(235, 98, 0);
  cursor: pointer;
  white-space: nowrap;
  opacity: 1;

  &:hover {
    transform: translateY(-1px);
    background-color: rgb(255, 134, 20);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 8px 14px;
    font-size: 16px;
    border-width: 2px;
  }
`;